<template>
  <div class="laypanel">
    <el-tabs :tab-position="tabPosition" style="height: 200px;">
      <el-tab-pane label="三方物流名称">
        <el-table
          stripe
          :data="wuliudata">
          <el-table-column
            prop="id.Int64"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="lname"
            label="三方物流名称">
          </el-table-column>
          <el-table-column
            prop="lcontact"
            label="联系方式">
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="50px"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="删除分类">
                <i class="fa fa-trash-o fa-lg curpointer" v-on:click="wuliudata(scope.$index, orderdata)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="物流费用">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'PSManage',
  data () {
    return {
      tabPosition: [],
      wuliudata: [],
      khid: ''
    }
  },
  mounted: function () {
    that = this
    console.log(that)
    var v = getCookie('cusid')
    this.khid = v
    that = this
    var qstr = 'id > 0'
    that.$http({
      url: 'https://api.sqnetsoft.cn/order/gotl',
      method: 'post',
      data: {
        whereinfo: {String: qstr, Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          var objtmp = JSON.parse(res.data.data)
          console.log(objtmp)
          that.wuliudata = JSON.parse(res.data.data)
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/cpmana/PSManage.vue